import React, { useEffect, useState } from 'react'

const CountdownTimer = ({ time, callback }) => {
  const calculateTimeLeft = () => {
    const difference = Math.max(+time - +new Date(), 0)
    return {
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    }
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())
  const formatTime = (value) => value.toString().padStart(2, '0')

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)

    return () => clearTimeout(timer)
  }, [timeLeft])

  useEffect(() => {
    if (timeLeft.minutes === 0 && timeLeft.seconds === 0) {
      callback()
    }
  }, [callback, timeLeft.minutes, timeLeft.seconds])

  return (
    <div className="countdown_timer">
      {timeLeft.minutes || timeLeft.seconds
        ? `${formatTime(timeLeft.minutes)}:${formatTime(timeLeft.seconds)}`
        : '--:--'}
    </div>
  )
}

export default CountdownTimer
